import i18n from "../i18n";

const DEFAULT_DATETIME_OPTIONS = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
};

const DEFAULT_DATE_OPTIONS = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const getUserLocale = () => (i18n?.language || navigator?.language || "en-US").replace("_", "-");
const getUserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const safeFormat = (dateString, formatterFactory) => {
    if (!dateString) return "-";
    try {
        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) throw new Error("Invalid date");
        return formatterFactory(date);
    } catch (err) {
        console.error("Invalid date:", dateString, err);
        return "-";
    }
};

export const formatToLocalTime = (dateString, options = {}) =>
    safeFormat(dateString, (date) =>
        new Intl.DateTimeFormat(getUserLocale(), {
            ...DEFAULT_DATETIME_OPTIONS,
            timeZone: getUserTimeZone(),
            ...options,
        }).format(date)
    );

export const formatToLocalDate = (dateString, options = {}) =>
    safeFormat(dateString, (date) =>
        new Intl.DateTimeFormat(getUserLocale(), {
            ...DEFAULT_DATE_OPTIONS,
            timeZone: getUserTimeZone(),
            ...options,
        }).format(date)
    );
